import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import VMasker from 'vanilla-masker'

import '../../../../../scss/profile.scss'


document.addEventListener("DOMContentLoaded", function() {
    
    function getCookie(name) {
        return document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))?.split('=')[1];
    }
    
    document.querySelectorAll('.swiper').forEach(function(el) {
        new Swiper(el, {
            // configure Swiper to use modules
            modules: [Navigation, Pagination, Autoplay],
            direction: 'horizontal',
            loop: true,
    
            autoplay: {
                delay: 7000,
            },
    
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
    
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function () {
                    this.el.classList.add('swiper-finished');
                },
                slideChangeTransitionEnd: function () {
                    this.el.classList.add('swiper-finished');
                },
                slideChangeTransitionStart: function () {
                    this.el.classList.remove('swiper-finished');
                }
            }
    
        });
    })

    const zoomables = document.querySelectorAll('img.zoomable')
    for (const zoom of zoomables) {
        new_zoom = zoom.cloneNode(true)
        a = document.createElement('a')
        a.setAttribute('href', zoom.src)
        a.classList.add('fresco')
        a.appendChild(new_zoom)
        zoom.replaceWith(a);
    }
    
    // new SimpleLightbox('a.fresco, .newsImageContainer a', {
    //     fileExt:false
    // })
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const searchFilter = document.getElementById('search-filter-toggle')
    if (searchFilter) {
        searchFilter.textContent = "Filtrar"
        searchFilter.addEventListener('click', function(e) {
            e.preventDefault();
            // $('.actionMenuContent').toggle('fast')
        })
    }

    const masks = document.querySelectorAll('[data-mask]')
    for(const input of masks) {
        const mask = input.dataset.mask
        VMasker(input).maskPattern(mask);
    }

    function logout() {
        var logoutBtn = document.getElementById('personaltools-logout')
        if (!logoutBtn) return 
        
        logoutBtn.addEventListener('click', function(e) {
            e.preventDefault()
            
            var url = this.getAttribute('href')
            var cookie = getCookie('__lt')
        
            if (cookie === 'govbr') {
                url = url.replace('cas_', '')
                var logout_url = "https://sso.acesso.gov.br/logout?post_logout_redirect_uri=" + url
                var form = document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", logout_url);
                document.body.appendChild(form);
                form.submit();
            }

            window.location.href = url
        })
    }

    logout()
});